import { Andamal } from 'models/apiModels/Andamal';
import { AndamalPut } from 'models/apiModels/AndamalPut';
import { HuvudgruppTyp } from 'models/apiModels/HuvudgruppTyp';
import { HuvudkategoriTyp } from 'models/apiModels/HuvudkategoriTyp';
import { AndamalTag } from 'models/appModels/AndamalTag';

export const andamalToAndamalPut = (andamal: Andamal): AndamalPut => ({
  andamal_id: andamal.andamal_id,
  kategorityp: andamal.kategorityp
});

export const andamalTagToAndamalPut = (andamalTag: AndamalTag): AndamalPut => ({
  andamal_id: andamalTag.id,
  kategorityp: andamalTag.kategorityp
});

export const convertFromAndamalToAndamalTag = (
  andamal: Array<Andamal>,
  kategorityper: Array<HuvudgruppTyp>
): Array<AndamalTag> => {
  const underKategorier =
    kategorityper
      .flatMap((huvudgrupp: HuvudgruppTyp) => huvudgrupp.huvudkategorier)
      .flatMap((huvudkategori: HuvudkategoriTyp) => huvudkategori.underkategorier) || [];

  const huvudKategorier = kategorityper.flatMap((huvudgrupp: HuvudgruppTyp) => huvudgrupp.huvudkategorier) || [];

  const kategoriDomain = [...underKategorier, ...huvudKategorier];

  return andamal.map((utkastAndamal) => {
    const andamal: any = kategoriDomain.find((item) => {
      if ('huvudkategorityp_id' in item && utkastAndamal.kategorityp === AndamalPut.KategoritypEnum.HUVUDKATEGORI) {
        return item.huvudkategorityp_id === utkastAndamal.andamal_id;
      } else if (
        'underkategorityp_id' in item &&
        utkastAndamal.kategorityp === AndamalPut.KategoritypEnum.UNDERKATEGORI
      ) {
        return item.underkategorityp_id === utkastAndamal.andamal_id;
      }
    });

    if (andamal) {
      const id = utkastAndamal.andamal_id;
      const namn = utkastAndamal.andamal_namn + (!andamal.aktiv ? ' (utfasad kategori)' : '');
      const kategorityp = utkastAndamal.kategorityp;
      const aktiv = andamal.aktiv;
      const nyckelord = andamal.nyckelord;
      const definitionstext = andamal['definitiontext'] || andamal['definitionstext'];

      return { id, namn, nyckelord, definitionstext, kategorityp, aktiv } as AndamalTag;
    }
    throw new Error('Onåbar, misslyckades med att konvertera ändamål');
  });
};
